import * as yup from 'yup'

const SchemaValidations = yup.object().shape({
  receiverEmail: yup.string().email('No es un correo válido'),
  // phone: yup.string().matches(/^[0-9]+$/, 'Invalid phone number'),
  receiverName: yup.string(),
  clientCode: yup.string(),
  receiverPhoneNumber: yup.string(),

  startDate: yup.date().nullable(),
  endDate: yup.date().nullable()
}).test(
  'date-requires-other-fields',
  'Si seleccionas una fecha, debes ingresar al menos uno de los siguientes campos: Correo Electrónico, Nombre de cliente, N° Documento o N° celular.',
  (values) => {
    const { startDate, endDate, receiverEmail, receiverName, clientCode, receiverPhoneNumber } = values;
    
    const isDateSelected = !!startDate || !!endDate;
    const isOtherFieldFilled = receiverEmail || receiverName || clientCode || receiverPhoneNumber;

    if (isDateSelected && !isOtherFieldFilled) {
      return false;
    }
    return true;
  }
)

export default SchemaValidations